export const createVersionBroadcastChannel = ({
  channelName,
  onMessage,
  onMessageError
}) => {
  if (typeof BroadcastChannel !== 'function') return null;

  // eslint-disable-next-line compat/compat
  const channel = new BroadcastChannel(`${channelName}-version-deprecation`);
  channel.onmessage = onMessage;
  channel.onmessageerror = messageErrorEvent => {
    const messageData = messageErrorEvent && messageErrorEvent.data ? messageErrorEvent.data : {};
    onMessageError(new Error(`Message Error in Version Broadcast Channel`), {
      messageData
    });
  };
  return channel;
};